import { Link } from 'react-router-dom';

const Footer = () => {
  const navigationLinks = [
    { name: 'Startseite', path: '/' },
    { name: 'Über Uns', path: '/uber-uns' },
    { name: 'Leistungen', path: '/leistungen' },
    { name: 'Wohnnetzwerk', path: '/wohnnetzwerk' },
    { name: 'Bewerbung', path: '/bewerbung' },
    { name: 'Kontakt', path: '/kontakt' }
  ];

  const legalLinks = [
    { name: 'Datenschutz', path: '/datenschutz' },
    { name: 'Impressum', path: '/impressum' },
    { name: 'AGB', path: '/agb' }
  ];

  const socialLinks = [
    {
      name: 'Instagram',
      icon: '📸',
      url: 'https://instagram.com/angeldevilnetwork'
    },
    {
      name: 'Twitter',
      icon: '🐦',
      url: 'https://twitter.com/angeldevilnet'
    },
    {
      name: 'TikTok',
      icon: '🎵',
      url: 'https://tiktok.com/@angeldevilnetwork'
    }
  ];

  return (
    <footer className="bg-deep-black/80 border-t border-white/10 py-12">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo und Beschreibung */}
          <div className="space-y-4">
            <Link to="/" className="block">
              <img src="/logo.png" alt="Angel & Devil Network" className="h-20 mb-4" />
            </Link>
            <p className="text-white/80">
              Angel & Devil Network – Where{" "}
              <span className="text-hot-pink">Temptation</span> Meets{" "}
              <span className="text-accent-purple">Talent</span>.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-xl font-playfair text-gradient mb-4">Navigation</h3>
            <ul className="space-y-2">
              {navigationLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-white/80 hover:text-hot-pink transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="text-xl font-playfair text-gradient mb-4">
              📧 Kontakt
            </h3>
            <div className="space-y-2 text-white/80">
              <p>
                <a
                  href="mailto:info@angel-devil.network"
                  className="hover:text-hot-pink transition-colors"
                >
                  info@angel-devil.network
                </a>
              </p>
              <p>📞 +1 (305) 777-6989</p>
              <div className="space-y-1">
                <p>📍 Angel & Devil Agency LLC</p>
                <p className="pl-4">7901 4th St N</p>
                <p className="pl-4">St. Petersburg, FL 33702</p>
                <p className="pl-4">USA</p>
              </div>
            </div>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-xl font-playfair text-gradient mb-4">
              🌐 Social Media
            </h3>
            <div className="flex flex-wrap gap-4">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="relative group"
                >
                  <div className="absolute -inset-1 bg-gradient-to-r from-hot-pink to-accent-purple rounded-lg blur opacity-25 group-hover:opacity-75 transition duration-300"></div>
                  <div className="relative glass-effect rounded-lg p-3">
                    <span className="text-2xl" role="img" aria-label={social.name}>
                      {social.icon}
                    </span>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/60 text-sm">
              © {new Date().getFullYear()} Angel & Devil Network. Alle Rechte vorbehalten.
            </p>
            <div className="flex flex-wrap justify-center gap-6">
              {legalLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  className="text-white/60 hover:text-hot-pink text-sm transition-colors"
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
